import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ILabel } from "@schema/label";

@Component({
  selector: "app-label-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"]
})
export class LabelListComponent implements OnInit {

  /**
   * The label to display
   */
  @Input()
  public labels: ILabel[];

  /**
   * If the user can edit (remove) the label
   */
  @Input()
  public isEditable = false;

  /**
   * Event for when the label's X is clicked (when applicable)
   */
  @Output()
  public removeFromCollection = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  public remove(labelId: string): void {
    this.removeFromCollection.emit(labelId);
  }

}
